export class InputBinding {
  /** String value for 'labeling' (introduction text, typically above) the input. */
  public label = "@";

  /** String value for 'captioning' (annotation text, typically below) the input. */
  public caption = "@";

  /** The type of input. Supported types are "text" | "email" | "password" | "number" | "date" | "time" | "tel" */
  public type = "@";

  /** Placeholder text for the input. When not provided, the placeholder will be empty. */
  public placeholder = "@?";

  /** The model to bind the input to. */
  public model = "=";

  /** The identifier for all business intelligence (BI) actions triggered by this component.*/
  public biId = "@?";

  /** Hide input and display model in label.*/
  public hideInputAndShowAsLabel = "<";

  public isRequired = "<";

  public ariaLabel = "@";
}

/** Various input types to be used. */
type Type = "text" | "email" | "password" | "number" | "date" | "time" | "tel";

/** Controller class for sdInput component. */
class Input {
  public label: string;
  public caption: string;
  public placeholder: string;
  public type: Type;
  public model: any;
  public biId: string;

  public $onInit(): void { }

  public $onChanges(changesObj: any): void { }
}
export const sdInput: ng.IComponentOptions = {
  controller: Input,
  templateUrl: "../ShellCommon/Controls/input/input.html",
  bindings: <any>new InputBinding()
};
